<template>
    <div
        @click="$router.push(`/produkte/${data.slug.name}`)"
        class="rounded-md shadow-md hover:shadow-lg p-4 flex flex-row items-center gap-4 cursor-pointer"
        :class="animate ? 'transition-all ease-in-out group' : ''"
    >
        <div class="w-12 h-12 rounded-md text-white flex-shrink-0">
            <img :alt="$translate(data.name)" :src="data.image.replace('.png', '-gradient.png')" class="w-full h-full object-contain" />
        </div>
        <div class="group-hover:ml-2 transition-all ease-in-out">
            <strong class="line-clamp-1 text-ellipsis overflow-hidden wrap-none text-sm">
                <!--<strong  v-if="data.slug.name == 'china-titans'" class="text-blue">NEU: </strong>-->
                {{ $translate(data.name) }}
            </strong>
            <small class="link">
                {{ $t('payment_book_now') }}
            </small>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        data: Object,
        backgroundColor: String,
        backgroundGradient: String,
        animate: Boolean
    },

    computed: {
        link() {
            return this.getApplicationType() === 'backend' ? '/dashboard/produkte/' + this.productgroup.slug.name : '/produkte/' + this.productgroup.slug.name;
        },
        ...mapGetters('settings', {
            getApplicationType: 'getApplicationType'
        })
    }
};
</script>

<style scoped>
.link {
    color: v-bind(backgroundColor);
}
</style>
